export const navigateBack = (navigate, fallbackPath, options = {}) => {
  const { replace = true } = options;
  const historyIndex = window.history.state?.idx;

  if (typeof historyIndex === 'number' ? historyIndex > 0 : window.history.length > 1) {
    navigate(-1);
    return;
  }

  navigate(fallbackPath, { replace });
};
